export default __webpack_public_path__ + "static/white-878e7b7c3758fba191feb739ff53f3f7.jpg";